import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from "@material-ui/core/StepConnector";
import { withStyles } from "@material-ui/core/styles";
import { ArrowBack } from "@material-ui/icons";
import StepIcon from "./StepIcon";

const BrandConnector = withStyles({
  root: { flex: "0 0 auto", display: "flex", alignItems: "center", padding: 0, margin: "0 2px" },
  horizontal: { paddingTop: 0 },
  active: { "& $line": { borderColor: "#e70017" } },
  completed: { "& $line": { borderColor: "#e70017" } },
  line: {
    display: "block",
    width: 100,
    borderTopStyle: "solid",
    borderTopWidth: 1,
    borderColor: "#d7d7d7",
  },
})(StepConnector);

const useStyles = makeStyles({
  header: {
    display: "flex",
    gap: 16,
    alignItems: "center",
    justifyContent: "space-between",
    padding: "24px 24px 0 24px",
  },
  stepper: {
    padding: "0 !important",
    backgroundColor: "transparent",
    flexShrink: 0,
  },
  stepLabel: {
    fontSize: "16px !important",
    fontWeight: "400 !important",
    lineHeight: "normal !important",
    whiteSpace: "nowrap",
    color: "#999 !important",
    marginTop: "0 !important",
  },
  stepLabelActive: { color: "#e70017 !important" },
  stepLabelCompleted: { color: "#e70017 !important" },
  iconContainer: {
    display: "flex !important",
    alignItems: "center !important",
    paddingRight: "8px !important",
  },
  labelContainer: { whiteSpace: "nowrap" },
  backIcon: { cursor: "pointer", color: "#e70017", fontSize: 20, flexShrink: 0 },
  spacer: { width: 20, height: 20, flexShrink: 0 },
});

const STEPS = ["MÉTODO DE COLETA", "VALIDAÇÃO DA RETIRADA"];

export const ColetaStepper = ({ step, onBack }) => {
  const classes = useStyles();

  return (
    <Box className={classes.header}>
      {step === 2 ? (
        <ArrowBack className={classes.backIcon} onClick={onBack} />
      ) : (
        <Box className={classes.spacer} />
      )}

      <Stepper
        nonLinear
        activeStep={step - 1}
        connector={<BrandConnector />}
        className={classes.stepper}
      >
        {STEPS.map((label, index) => {
          const isActive = index === step - 1;
          const isCompleted = index < step - 1;
          return (
            <Step
              key={label}
              active={isActive}
              completed={isCompleted}
            >
              <StepLabel
                StepIconComponent={StepIcon}
                classes={{
                  label: classes.stepLabel,
                  active: classes.stepLabelActive,
                  completed: classes.stepLabelCompleted,
                  iconContainer: classes.iconContainer,
                  labelContainer: classes.labelContainer,
                }}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>

      <Box className={classes.spacer} />
    </Box>
  );
};

